import type {LTServices} from "../lt-ng/lt-services";
import {IToastService, TOAST_DURATION_SNACKBAR} from "./ToastService";
import type {L} from "../lt-ng/landcare-toolkit";
import {ModalService} from "../controllers/geoapp";
import {Source} from "ol/source";
import {default as Base} from 'ol/layer/Base';
import TileLayer from "ol/layer/Tile";

export interface ITileErrorMonitoring {
    init();
}

export class TileErrorMonitoringService implements ITileErrorMonitoring {
    public static $inject = ['landcareMapService', 'toastService', '$uibModal'];

    constructor(protected mapService: LTServices.IMapService, protected toastService: IToastService, protected uibModal: ModalService) {

    }

    // protected showingToast = false;

    init() {
        let onError = (source: Source) => {
            return () => {
                const layerService = <L.util.LayerService> source.get('layerService');
                const layerTitle = layerService && layerService.description || 'map';

                this.toastService.showToast(
                    `Error loading some ${layerTitle} images`,
                    TOAST_DURATION_SNACKBAR,
                    'cod-gray',
                    {
                        label: "more info",
                        onClick: () => {
                            console.log('toast click');
                            this.uibModal.open({
                                component: 'tileErrorModal',
                                resolve: {
                                    layer: layerService
                                }
                            });
                        }
                    }
                );

                /*if (!this.showingToast) {

                    this.showingToast = true;
                    setTimeout(() => {
                        this.showingToast = false
                    }, TOAST_DURATION_LONG);
                }*/
            };
        };

        let listenToLayer = (layer : Base) => {
            if (layer.get('tileErrorServiceListening')) {
                return;
            }

            if (layer instanceof TileLayer) {
                try {
                    layer.getSource().on('tileloaderror', onError(layer.getSource()));
                    layer.set('tileErrorServiceListening', true);
                } catch (e) {
                    console.warn(e);
                }
            }
        };

        this.mapService.mapPromise.then((map) => {
            let layers = map.getLayers();
            layers.getArray().forEach(listenToLayer);

            layers.on('add', (ev) => {
                let el = ev.element;
                listenToLayer(el);
            });
        });
    }
}
